<template>
    <div class="o-menu">
        <div>
            <div v-if="authUser" class="o-menu__header">
                <a-icon icon="UserWhite" class="o-menu__headerIcon" />
                <div>
                    <p class="o-menu__headerTitle">
                        {{ authUser.first_name }} {{ authUser.last_name }}
                    </p>
                    <p class="o-menu__headerSubtitle">{{ authUser.email }}</p>
                </div>
            </div>
            <a-button
                :disabled="disabledMenuItems"
                class="o-menu__button"
                type="fullwidth-light"
                icon="Dashboard"
                @click="navigation('dashboard')"
                :process-on-click="true"
            >
                Pulpit
            </a-button>
            <a-button
                :disabled="disabledMenuItems"
                class="o-menu__button"
                type="fullwidth-light"
                icon="Envelope"
                @click="navigation('contact')"
            >
                Kontakt z doradcą
            </a-button>
            <a-button
                :disabled="disabledMenuItems"
                class="o-menu__button"
                type="fullwidth-light"
                icon="Invoice"
                @click="navigation('invoices')"
            >
                Lista faktur
            </a-button>
            <a-button
                :disabled="disabledMenuItems"
                class="o-menu__button"
                type="fullwidth-light"
                icon="Packages"
                @click="navigation('subscriptionsList')"
                :process-on-click="true"
            >
                Pakiety (subskrypcje)
            </a-button>
            <a-button
                :disabled="disabledMenuItems"
                v-if="authIsAdvisor"
                class="o-menu__button"
                type="fullwidth-light"
                icon="UserAdd"
                @click="navigation('user-add')"
                :process-on-click="true"
            >
                Dodaj użytkownika
            </a-button>
            <a-button
                :disabled="disabledMenuItems"
                v-if="authIsAdvisor"
                class="o-menu__button"
                type="fullwidth-light"
                icon="Users"
                @click="navigation('users')"
                :process-on-click="true"
            >
                Moi klienci
            </a-button>
            <a-button
                :disabled="disabledMenuItems"
                class="o-menu__button"
                type="fullwidth-light"
                icon="Notifications"
                @click="navigation('notifications')"
                :process-on-click="true"
            >
                Powiadomienia
            </a-button>
            <a-button
                class="o-menu__button o-menu__button--last"
                type="fullwidth-light"
                icon="Settings"
                @click="navigation('settings')"
                :process-on-click="true"
            >
                Ustawienia
            </a-button>
            <a-button
                type="fullwidth"
                icon="LogoutLight"
                @click="navigation('logout')"
                :process-on-click="true"
            >
                Wyloguj
            </a-button>
        </div>
        <p class="o-menu__version" @click="showOneSignalId = !showOneSignalId">
            v{{ version }}
            <span v-if="environment !== 'production'">{{ environment }}</span>
        </p>
        <p v-if="showOneSignalId" class="o-menu__version">{{ oneSignalId }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showOneSignalId: false
        }
    },
    computed: {
        disabledMenuItems() {
            return !this.$store.getters[
                'subscriptions/userHasActiveSubscription'
            ]
        },
        version() {
            return process.env.PACKAGE_VERSION
        },
        environment() {
            return process.env.VUE_APP_MODE
        },
        authUser() {
            return this.$store.getters.authUser
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        },
        oneSignalId() {
            return this.$store.getters.authOneSignalId
        }
    },
    methods: {
        navigation(name) {
            this.$router.push({ name }).catch(() => {
                this.$store.dispatch('hideMenu')
            })
        }
    },
    created() {
        this.$store.dispatch('authLoadToken')
    }
}
</script>
